import FirestoreService from "../firestore";
import { AssimagraMetrics, CompanyWithFootprint } from "../../types/assimagra/assimagra-metrics.types";

interface FirestoreResponse {
    success?: boolean;
    data?: any;
    message?: string;
    [key: string]: any;
}

export class AssimagraService {
    static async getMetrics(userId: string): Promise<AssimagraMetrics | null> {
        try {
            console.log("AssimagraService.getMetrics called for user:", userId);
            const response = await FirestoreService.request("get-assimagra-metrics", {}, "assimagra_metrics", userId) as FirestoreResponse;
            console.log("AssimagraService.getMetrics response:", response);

            const metricsData = response.entity?.data || null;
            console.log("Extracted metrics data:", metricsData);
            return metricsData;
        } catch (error) {
            console.error("Error getting Assimagra metrics:", error);
            throw error;
        }
    }

    static async refreshMetrics(userId: string): Promise<AssimagraMetrics | null> {
        try {
            console.log("AssimagraService.refreshMetrics called for user:", userId);
            const response = await FirestoreService.request("refresh-assimagra-metrics", {}, "assimagra_metrics", userId) as FirestoreResponse;
            console.log("AssimagraService.refreshMetrics response:", response);

            const metricsData = response.entity?.data || null;
            console.log("Extracted refresh metrics data:", metricsData);
            return metricsData;
        } catch (error) {
            console.error("Error refreshing Assimagra metrics:", error);
            throw error;
        }
    }

    static async getCompaniesWithFootprints(userId: string): Promise<CompanyWithFootprint[]> {
        try {
            console.log("AssimagraService.getCompaniesWithFootprints called for user:", userId);
            const response = await FirestoreService.request("get-companies-with-footprints", {}, "companies", userId) as FirestoreResponse;
            console.log("AssimagraService.getCompaniesWithFootprints response:", response);

            const companiesData = response.entity?.data || [];
            console.log("Extracted companies data:", companiesData);
            return Array.isArray(companiesData) ? companiesData : [];
        } catch (error) {
            console.error("Error getting companies with footprints:", error);
            throw error;
        }
    }
} 